let base = {
    "/": require("@/module/layout/home/Dashboard.vue"),

    //基础信息
    "/basicinfomgr/Mould": require("@/module/cnetong/client/basicinfomgr/mould/Mould.vue"),
    "/basicinfomgr/SysPara": require("@/module/cnetong/client/basicinfomgr/syspara/SysPara.vue"),
    "/basicinfomgr/SysCode": require("@/module/cnetong/client/basicinfomgr/syscode/SysCode.vue"),
    "/basicinfomgr/ImplClass": require("@/module/cnetong/client/basicinfomgr/implclass/ImplClass.vue"),

    //基础配置
    "/basics/EasyConfig": require("@/module/cnetong/client/basics/EasyConfig"),
    //资源管理
    "/rsrcmgr/Conn": require("@/module/cnetong/client/rsrcmgr/conn/Conn.vue"),
    "/rsrcmgr/Rc": require("@/module/cnetong/client/rsrcmgr/rc/Rc.vue"),
    "/rsrcmgr/BizChain": require("@/module/cnetong/client/rsrcmgr/bizchain/BizChain.vue"),

    //监控管理
    "/monitormgr/Error": require("@/module/cnetong/client/monitormgr/Error.vue"),
    "/monitormgr/Block": require("@/module/cnetong/client/monitormgr/Block.vue"),
    "/monitormgr/PersistentTmp": require("@/module/cnetong/client/monitormgr/PersistentTmp.vue"),
    "/monitormgr/PersistentFile": require("@/module/cnetong/client/filepersistent/FilePersistent.vue"),

     // 高级配置管理
    "/config/Senior": require("@/module/cnetong/client/seniormgr/IdConfigMgr.vue"),
    "/config/SysPara": require("@/module/cnetong/client/basicinfomgr/syspara/SysPara.vue"),
    "/config/Monitor": require("@/module/cnetong/client/seniormgr/Monitor.vue"),
    "/config/Sm": require("@/module/cnetong/client/sm/SmConfigMgr.vue"),
};

export default base;